import u from "../../../util";
import {DesktopGuide} from "../../../components/desktop-guide/";
import * as TwoFactorPop from "../../../components/twofactor-pop/";
import {SignUpViewChanger} from "../../renewal-signup/util/view-changer/";

export const setGlobal = () => (global => {
    global.util = u;
    global.DesktopGuide = DesktopGuide;
    global.TwoFactorPop = TwoFactorPop;
    global.SignUpViewChanger = SignUpViewChanger;
})(window);